import { Observable, timer } from 'rxjs';
import { finalize } from 'rxjs/operators';

export function withDelayedLoadingIndicator<T>(
  source: Observable<T>,
  setLoading: (isLoading: boolean) => void,
  delayMs: number
): Observable<T> {
  let indicatorShown = false;

  const delayedTrigger = timer(delayMs).subscribe(() => {
    indicatorShown = true;
    setLoading(true);
  });

  return source.pipe(
    finalize(() => {
      delayedTrigger.unsubscribe();
      if (indicatorShown) {
        setLoading(false);
      }
    })
  );
}
